module.exports = {
      id: "google-g-usage",
      viewBox: "0 0 46 46",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#google-g",
      toString: function () {
        return this.url;
      }
    }